import React from 'react';
import { GridContainer } from '../../shared/grid';
import { HelpHeader } from '../../features/help-page/header/HelpHeader'
import { Videos } from '../../features/help-page/video/Videos';

export const Help: React.FC = () =>{
  return(
  <GridContainer className="margin-top-6">
      <HelpHeader/>
      <Videos/>
  </GridContainer>
  )
}